import { __awaiter } from "tslib";
import { InstrumentationBase, } from '@opentelemetry/instrumentation';
import { MEMORY_USAGE_INSTRUMENTATION_NAME, MEMORY_USAGE_INSTRUMENTATION_VERSION, } from './memory-usage.utils';
import { getSdkConfig } from '../../helpers';
import { CoralogixEventType } from '../../types';
import { CoralogixAttributes } from '../../constants';
export class CoralogixMemoryUsageInstrumentation extends InstrumentationBase {
    disable() {
        this.clearMeasurementsInterval();
    }
    enable() {
        this.startTrackingMemoryUsage();
    }
    init() { }
    constructor(config) {
        super(MEMORY_USAGE_INSTRUMENTATION_NAME, MEMORY_USAGE_INSTRUMENTATION_VERSION, config);
        this.memoryUsageInterval = getSdkConfig().memoryUsageConfig.interval;
    }
    startTrackingMemoryUsage() {
        this.clearMeasurementsInterval();
        this.createMemorySample().then(() => this.runMemoryMeasurements());
    }
    createMemorySample() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const memoryUsage = yield performance.measureUserAgentSpecificMemory();
                const memoryUsageSpan = this.tracer.startSpan(MEMORY_USAGE_INSTRUMENTATION_NAME);
                memoryUsageSpan[CoralogixAttributes.EVENT_TYPE] =
                    CoralogixEventType.MEMORY_USAGE;
                memoryUsageSpan[CoralogixAttributes.MEMORY_USAGE_CONTEXT] = memoryUsage;
                memoryUsageSpan.end();
            }
            catch (error) {
                console.warn('Memory usage measurement failed', error);
                this.clearMeasurementsInterval();
            }
        });
    }
    runMemoryMeasurements() {
        this.timeoutId = setTimeout(() => this.measureMemoryUsage(), this.memoryUsageInterval);
    }
    measureMemoryUsage() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createMemorySample();
            this.runMemoryMeasurements();
        });
    }
    clearMeasurementsInterval() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
}
